"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMobile = void 0;
var react_1 = require("@chakra-ui/react");
function useIsMobile() {
    return (0, react_1.useBreakpointValue)({ base: true, md: false });
}
exports.useIsMobile = useIsMobile;
